<template>
  <div>
    <b-card no-body>
      <b-card-body class="border border-dashed border-top-0 border-end-0 border-start-0 mb-3">
        <b-form>
          <b-row class="g-3">
            <b-col>
              <div class="search-box">
                <input type="text" class="form-control search" v-model="filter_value.keyword"
                       :placeholder="this.$t('page.contract_name')" />
                <i class="ri-search-line search-icon"></i>
              </div>
            </b-col>
            <b-col cols="12" md="auto">
              <div class="align-content-end">
                <b-button type="button" variant="success" @click="doFilter" class="me-3">
                  <i class="ri-equalizer-fill me-1 align-bottom"></i>
                  {{this.$t('page.filter')}}
                </b-button>
                <b-button type="button" variant="primary" class="add-btn" @click="add" v-perm="editPermissionCode">
                  <i class="ri-add-line align-bottom me-1"></i> {{this.$t('base.add')}}
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
      <b-card-body class="pt-0 flex-grow-1">
        <div>
          <div class="table-responsive table-card mb-1">
            <table class="table table-nowrap align-middle">
              <thead class="text-muted table-light">
              <tr class="text-uppercase">
                <template v-for="(item, index) in tableHeaders" :key="index">
                  <th v-show="item.visible">{{ item.label }}</th>
                </template>
                <th>
                  {{this.$t('base.operation')}}
                </th>
              </tr>
              </thead>
              <tbody class="list form-check-all">
              <tr v-for="(item, index) in dataList" :key="index">
                <template v-for="(titleItem, titleIdx) in tableHeaders" :key="titleIdx">
                  <td v-show="titleItem.visible">
                    <span v-if="titleItem.name == 'period'">{{ formatPeriod(item.begin_at, item.end_at) }}</span>
                    <span v-else-if="titleItem.name == 'status' && statusValid(item.end_at)" class="badge badge-soft-info">{{this.$t('page.valid')}}</span>
                    <span v-else-if="titleItem.name == 'status' && !statusValid(item.end_at)" class="badge badge-soft-dark">{{this.$t('page.expired')}}</span>
                    <span v-else>{{ item[titleItem.name] }}</span>
                  </td>
                </template>
                <td>
                  <i class="ri-eye-fill fs-3 text-primary me-3 cursor-pointer" @click="showDetail(item, false)"></i>
                  <i class="ri-edit-2-line fs-3 text-primary me-3 cursor-pointer" @click="edit(item)" v-perm="editPermissionCode"></i>
                  <i class="ri-delete-bin-line fs-3 text-primary me-3 cursor-pointer" @click="del(item)" v-perm="editPermissionCode"></i>
                </td>
              </tr>
              </tbody>
            </table>
            <table-loading :table-loading="tableLoading" :table-loaded="tableLoaded" :count="count"></table-loading>
          </div>
        </div>
        <Pagination
            v-if="tab_info_length"
            v-model:page="page"
            v-model:perPage="perPage"
            :pages="pages"
            :prePageOption="prePageOption"
            :tab_info_length="tab_info_length"
            @update:page="pageChange"
            @update:perPage="pageSizeChange"
            class="me-5 my-3"
        ></Pagination>
        <add-contract ref="addContract" :customer-id="customerId" :customer-name="customerName" @refresh="_getFirstPage"></add-contract>
      </b-card-body>
    </b-card>
  </div>
</template>
<script>
import _ from "lodash";
import {
  getCustomerContract,
  deleteCustomerContract,
} from "@/service"
import tableLoading from "@/views/widgets/table-loading";
import {successMsg, alertComfirm} from "@/helpers/swal";
import {formatDatetime} from "@/helpers/common";
import addContract from "@/views/customer/components/add-contract";
export default {
  props: {
    customerName: {
      type: String,
      default: ''
    },
    // 编辑权限code
    editPermissionCode: {
      type: String,
      default: null
    },
    // 初始加载合同列表
    initLoad: {
      type: Boolean,
      default: true
    },
  },
  components: {
    tableLoading,
    addContract,
  },
  data () {
    return {
      customerId: null,
      /* 分页start */
      tab_info_length: 0,
      page: 1,
      perPage: 10,
      prePageOption: [10, 20, 30, 40, 50],
      pages: [],
      /* 分页end */
      tableHeaders: [
        {
          name: 'name',
          label: this.$t('page.contract_name'),
          visible: true
        },
        // {
        //   name: 'type',
        //   label: '合同类型',
        //   visible: true
        // },
        {
          name: 'party_a_txt',
          label: this.$t('page.first_party'),
          visible: true
        },
        {
          name: 'party_b_txt',
          label: this.$t('page.second_party'),
          visible: true
        },
        {
          name: 'period',
          label: this.$t('page.contract_life'),
          visible: true
        },
        {
          name: 'status',
          label: this.$t('page.user.status'),
          visible: true
        },
      ],
      tableLoading: false,
      tableLoaded: false,
      dataList: [],
      count: 0,
      filters: {
        page: 1,
        page_size: 10,
        party_a: null,
      },
      filter_value: {
        keyword: '',
      },
    }
  },
  mounted() {
    this.customerId = this.$route.params.id
    if (this.initLoad) {
      this._getFirstPage()
    }
  },
  methods: {
    /* 设置分页选项 */
    setPages() {
      this.pages = [];
      this.tab_info_length = this.count;
      let numberOfPages = Math.ceil(this.count / this.perPage);
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    add() {
      this.$refs.addContract.open()
    },
    edit(item) {
      this.$refs.addContract.open(item)
    },
    showDetail(item, showKeyword = true) {
      // 当前列表中显示一条合同，并在搜索框显示合同名称
      if (showKeyword) {
        this.filter_value.keyword = item.name
        this.count = 1
        this.dataList = [item]
      }
      this.$refs.addContract.open(item, true)
    },
    // 删除
    del(item) {
      alertComfirm().then(res => {
        if (res) {
          deleteCustomerContract(item.id).then(() => {
            successMsg(this.$t('base.delete_success'))
            this._getFirstPage()
          })
        }
      })
    },
    statusValid(end_at) {
      if (!end_at) {
        return true
      }
      const today = formatDatetime(new Date(), 'YYYY-MM-DD')
      return today <= end_at
    },
    formatPeriod(start, end) {
      return formatDatetime(start, 'YYYY/MM/DD') + ' - ' + formatDatetime(end, 'YYYY/MM/DD')
    },
    // 筛选
    doFilter () {
      this.orders = []
      const search = {
        keyword: null,
      }
      if (this.filter_value.keyword) {
        search['keyword'] = this.filter_value.keyword
      }
      this.filters = _.assign(this.filters, search)
      this._getFirstPage()
    },
    // 翻页
    pageChange(val) {
      this.filters.page = val
      this._getList()
    },
    // 设置每页条数
    pageSizeChange(val) {
      this.filters.page_size = val
      this._getFirstPage()
    },
    // 获取数据
    _getFirstPage() {
      this.filters.page = 1;
      // 针对从设备全生命周期过来+编辑后刷新页面的情况
      if (!this.initLoad) {
        this.filter_value.keyword = this.filters.keyword
      }
      this._getList()
    },
    _getList() {
      this.filters.page_size = this.perPage
      this.filters.party_a = this.customerId
      this.tableLoading = true
      this.tableLoaded = false
      getCustomerContract(this.filters).then(res => {
        this.tableLoading = false
        this.tableLoaded = true
        this.dataList = res.payload.results
        this.count = res.payload.count
        this.setPages()
      }).catch(err => {
        console.log(err)
      })
    },
  }
}
</script>
<style scoped>


</style>
